import { useState } from 'react';
import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Dialog, DialogContent, DialogTitle, IconButton, DialogActions, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import SaveIcon from '../../icons/save-icon.png'
import { Alert, LoadingButton } from '@mui/lab';

//import styles from './edit-card.module.scss';

const AddCardModal = observer(({ show, setShow, uiStore, history }) => {
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('Private');
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const confirm = async () => {
        if (name) {
            setError('');
        } else {
            return setError('Please enter a Card name first');
        }
        setLoading(true);
        const id = await uiStore.createCard(name, type === 'Private' ? false : true);
        history.push('/edit-card/' + id);
        setShow(false);
        setLoading(false);
    }

    return (
        <Dialog open={show} maxWidth='xs' fullWidth onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Create new card
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }
                <Typography fontSize={14} color='#888'>Complete the following information to create a card</Typography>
                <TextField
                    label='Card Name'
                    sx={{ mt: 2 }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <RadioGroup sx={{ mt: 3 }} value={type} onChange={(e) => setType(e.target.value)}>
                    <FormControlLabel
                        value="Public"
                        control={<Radio />}
                        label={<>
                            <Typography fontSize={14}>Public (Paid)</Typography>
                            <Typography fontSize={12} color='#888'>Everyone can see this Card</Typography>
                        </>}
                        sx={{ mb: 2 }}
                    />

                    <FormControlLabel
                        value="Private"
                        control={<Radio />}
                        label={<>
                            <Typography fontSize={14}>Private (Free)</Typography>
                            <Typography fontSize={12} color='#888'>People must send request to access this Card</Typography>
                        </>}
                    />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={!!loading} onClick={confirm} variant="contained" color="secondary"
                    endIcon={<img src={SaveIcon}
                        alt='Save icon'
                        width={24}
                    />}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
});

export default AddCardModal;
